// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"634e4662","455":"4dfb5287","977":"781cce73"}[chunkId] + ".chunk.js";
};